import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-our-clients-icons',
  templateUrl: './our-clients-icons.component.html',
  styleUrls: ['./our-clients-icons.component.scss']
})
export class OurClientsIconsComponent implements OnInit {
  @Input() pricingLink!:string;

  Images: any[] = [
    { image: './assets/images/client/01.svg', class:"border-r" },
    { image: './assets/images/client/02.png' },
    { image: './assets/images/client/03.png' },
    { image: './assets/images/client/04.png' },
    { image: './assets/images/client/05.png' },
    { image: './assets/images/client/06.png' },
    { image: './assets/images/client/07.png' },
    { image: './assets/images/client/08.png' },
    { image: './assets/images/client/09.png' },
    { image: './assets/images/client/10.png' },
    { image: './assets/images/client/11.png' },
    { image: './assets/images/client/12.png' },
    { image: './assets/images/client/13.png' },
    { image: './assets/images/client/14.png' },
    { image: './assets/images/client/15.png' },
    { image: './assets/images/client/16.png' },
    { image: './assets/images/client/17.png' },
    { image: './assets/images/client/18.png' }

  ]
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute
  ) { }

  ngOnInit(): void {
    
  }

}
